<template>
  <div class="shop-layout">
    <Header />

    <!-- 고정된 좌측 사이드바 -->
    <LeftSidebar class="fixed-left-sidebar" />

    <!-- 메인 콘텐츠 (와이드한 디자인 유지) -->
    <main class="shop-content">
      <router-view />
    </main>

    <!-- 고정된 우측 사이드바 -->
    <RightSidebar class="fixed-right-sidebar" />

    <!-- TOP 버튼 -->
    <button class="top-button" @click="scrollToTop">
      <span>TOP</span>
    </button>

    <Footer />

    <!-- 팝업 표시 컴포넌트 -->
    <PopupDisplay />
  </div>
</template>

<script>
import Header from '@/views/shop/layouts/Header.vue'
import Footer from '@/views/shop/layouts/Footer.vue'
// import LeftSidebar from '@/views/shop/layouts/LeftSidebar.vue'
import RightSidebar from '@/views/shop/layouts/RightSidebar.vue'
import PopupDisplay from '@/components/common/PopupDisplay.vue'

export default {
  name: 'ShopLayout',
  components: {
    Header,
    Footer,
    // LeftSidebar,
    RightSidebar,
    PopupDisplay
  },
  mounted() {
    // 로그인 체크
    this.checkAuthentication();
  },
  methods: {
    checkAuthentication() {
      const userToken = localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token');

      if (!userToken) {
        console.log('🚨 ShopLayout: 로그인 토큰 없음 - 로그인 페이지로 이동');
        this.$router.push('/login');
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
}
</script>

<style>
.shop-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
}

.shop-content {
  min-height: calc(100vh - 60px - 100px); /* 헤더, 푸터 높이 제외 */
  padding: 20px 0;
  //max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

/* 고정된 사이드바 스타일 */
.fixed-left-sidebar {
  position: fixed;
  left:10%;
  top: 50%;
  transform: translateY(-50%);
  width: 120px; /* 이벤트 배너용 넓이 */
  z-index: 1000;
  background-color: white;
  border-radius: 0 8px 8px 0;
  box-shadow: 2px 0 10px rgba(0,0,0,0.1);
}

.fixed-right-sidebar {
  position: fixed;
  right: 2%;
  top: 50%;
  transform: translateY(-50%);
  width: 80px; /* 메뉴용 넓이 */
  z-index: 1000;
  background-color: white;
  border-radius: 8px 0 0 8px;
  box-shadow: -2px 0 10px rgba(0,0,0,0.1);
}

/* TOP 버튼 */
.top-button {
  position: fixed;
  right: 50px;
  bottom: 110px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #333;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  z-index: 1000;
  font-weight: bold;
}

@media (max-width: 768px) {
  .fixed-left-sidebar, .fixed-right-sidebar {
    display: none;
  }
}
</style>